/**
 * Public-safe ApiError constructors for envelope parse failures.
 * Never throw "Invalid JSON (500)" — customers see temporaryUnavailable copy.
 */
import { ApiError } from '../api/ApiClient.js';
import { resolvePublicApiFailureMessage } from './publicApiFailureMessage.js';

export function customerInvalidJsonApiError(status: number): ApiError {
  return new ApiError(
    resolvePublicApiFailureMessage({ status, code: 'INVALID_JSON' }),
    status,
    'INVALID_JSON',
  );
}

export function customerRequestFailedMessage(): string {
  return resolvePublicApiFailureMessage({ status: 500 });
}

/**
 * Build ApiError from a failed platform/public envelope.
 * Localizes CS/SK/EN wire strings and strips English jargon (e.g. Internal Server Error).
 */
function readEnvelopeErrorFields(body: unknown): {
  code: string | undefined;
  rawMessage: string | undefined;
} {
  if (body === null || typeof body !== 'object') {
    return { code: undefined, rawMessage: undefined };
  }
  const record = body as { success?: unknown; error?: unknown; code?: unknown };
  const topLevelCode = typeof record.code === 'string' ? record.code : undefined;
  if (typeof record.error === 'string') {
    return { code: topLevelCode, rawMessage: record.error };
  }
  if (record.error !== null && typeof record.error === 'object') {
    const nested = record.error as { code?: unknown; message?: unknown };
    return {
      code: typeof nested.code === 'string' ? nested.code : topLevelCode,
      rawMessage: typeof nested.message === 'string' ? nested.message : undefined,
    };
  }
  return { code: topLevelCode, rawMessage: undefined };
}

export function customerEnvelopeApiError(status: number, body: unknown): ApiError {
  const { code, rawMessage } = readEnvelopeErrorFields(body);
  const message = resolvePublicApiFailureMessage({
    status,
    code,
    rawMessage,
  });
  return new ApiError(message, status, code, body);
}
